//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		name: "competition-pools",
		props: ['id'],
		data() {
			return {
				tables: [],
				loader: true,
				competition: null,
			}
		},
		mounted() {
			this.loadPools();
		},
		methods: {
			loadPools() {
				window.Api.get('rugby/competitions/' + this.id + '/pools').then(response => {
					if (response.success) {
						this.tables = response.data.tables;
						this.competition = response.data.competition;
					}
					this.loader = false;
				});
			},

			css(index) {

				if( this.competition.id === 15 || this.competition.id === 17 ) {
					if( index <= 1 ) {
						return 'table-primary';
					} else if( index <= 5 && index >= 2 ) {
						return 'table-danger';
					} else {
						return 'table-light';
                    }
				}  else {
					return 'table-light';
				}
			}
		}
	}
